<template>
    <div class="d-flex flex-columns">
        <v-autocomplete
            dense
            outlined
            v-bind="$attrs"
            :items="collection ? collection.models : []"
            chips
            deletable-chips
            small-chips
            item-text="name"
            item-value="id"
            multiple
            :value="value"
            v-on="$listeners"
        >
            <template #item="data">
                <v-list-item-content>
                    <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'MailingListMultiselect',

    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        ...mapState('mailing_list', {
            loaded: 'loaded',
            collection: 'collection',
        }),
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('mailing_list', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
